import { Components, Theme } from "@mui/material";
export const muiGridTheme = (
    theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiGrid2"> => ({
    MuiGrid2: {},
});
